export default __webpack_public_path__ + "navigation-examples-advanced-v1-1200-f493108e584a9e2bdedb23d817b1068e.webp";